module.exports = __webpack_public_path__ + "img/lenovo-bg-content-3.8bbb77e.jpg";